import { render, staticRenderFns } from "./about-carousel.vue?vue&type=template&id=05a4d92a&"
import script from "./about-carousel.vue?vue&type=script&lang=js&"
export * from "./about-carousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports